import { FlexDiv, GenericP, GenericSpan } from 'commonStyles';
import {
	INVOICE_CONSTANTS,
	WALLET_CONSTANTS,
	APPLICATION_CONSTANTS,
	FILTER_CONSTANTS
} from '../AppConstants';
import {
	formatCurrency, formatAmount, validAmount, validDays,
	evaluateString
} from '../UtilityComponents/Util';

import React from 'react';
import { DotIcon, SpriteIcon } from './WalletStyles';
import { getConsulData } from 'UtilityComponents/index';

export const textsConfig = getConsulData('config')['WALLET']['textsConfig'];

/** Maps Consul onBoarding copy for useModuleCoachmark (heading + subHeading). */
export const walletCoachmarkTextConf = Object.keys(textsConfig?.onBoarding || {}).reduce((acc, key) => {
	const item = textsConfig.onBoarding[key];
	if (item && typeof item === 'object') {
		acc[key] = {
			heading: item.heading || '',
			subHeading: item.text || ''
		};
	}
	return acc;
}, {});
export const dateConfig = {

};

const balanceCardData = getConsulData('config')['WALLET']['balanceCardData'];

export const getBalanceCardData = (balanceDet, walletReminderExp, reminderSettings) => {
	if (!balanceDet) {
		return {
			error: true,
			type: 'apierror'
		};
	}
	let {
		daysLeft,
		rate,
		amount,
		minDays,
		defMinDays,
		walletStatus,
		minAmount,
		defMinAmount
	} = balanceDet;
	switch (walletStatus) {
		case 'LOOKS_GOOD':
			return {
				type: balanceCardData[walletStatus].type,
				title: balanceCardData[walletStatus].title,
				tag: balanceCardData[walletStatus].tag,
				walletIcon: balanceCardData[walletStatus].walletIcon,
				amount: amount,
				showAsterik: walletReminderExp && rate > 0,
				asterisk: {
					text: `${balanceCardData[walletStatus].asterisk.text1}${daysLeft} ${balanceCardData[walletStatus].asterisk.text2}`,
					tooltip: {
						title: balanceCardData[walletStatus].asterisk.tooltip.title,
						text1: `${balanceCardData[walletStatus].asterisk.tooltip.text1} ${APPLICATION_CONSTANTS.RUPEE} ${formatCurrency(rate)}`,
						text2: `${balanceCardData[walletStatus].asterisk.tooltip.text2} ${formatCurrency(amount, true)} / ${formatCurrency(rate)} = ${daysLeft} Days`
					}
				}
			};
			break;
		case 'ZERO_BALANCE':
			const showMinAmt = defMinAmount > minAmount ? defMinAmount : minAmount;
			return {
				type: balanceCardData[walletStatus].type,
				title: balanceCardData[walletStatus].title,
				walletIcon: balanceCardData[walletStatus].walletIcon,
				amount: 0,
				showAsterik: walletReminderExp,
				asterisk: {
					text: `${balanceCardData[walletStatus].asterisk.text1} ${formatCurrency(showMinAmt, true)} ${balanceCardData[walletStatus].asterisk.text2}`
				}
			};
		case 'RECHARGE_NEEDED':
			const showMinDays = (reminderSettings && reminderSettings.daysLeft) || defMinDays;
			return {
				type: balanceCardData[walletStatus].type,
				title: balanceCardData[walletStatus].title,
				walletIcon: balanceCardData[walletStatus].walletIcon,
				tag: balanceCardData[walletStatus].tag,
				amount: amount,
				showAsterik: walletReminderExp && rate > 0,
				asterisk: {
					text: `${balanceCardData[walletStatus].asterisk.text1} ${showMinDays} ${balanceCardData[walletStatus].asterisk.text2}`,
					tooltip: rate > 0 ? {
						title: balanceCardData[walletStatus].asterisk.tooltip.title,
						text1: `${balanceCardData[walletStatus].asterisk.tooltip.text1} ${APPLICATION_CONSTANTS.RUPEE} ${formatCurrency(rate)}`,
						text2: `${balanceCardData[walletStatus].asterisk.tooltip.text2} ${formatCurrency(amount, true)} / ${formatCurrency(rate)} = ${daysLeft} Days`
					} : false
				}
			};
		default:
			return {

			};
	}
};

export const RECHARGETEXT = getConsulData('config')['WALLET']['RECHARGETEXT'];

export const headerConfig = evaluateString(getConsulData('config')['WALLET']['headerConfig'])(WALLET_CONSTANTS);

export const cashbackHeaderConfig = evaluateString(getConsulData('config')['WALLET']['cashbackHeaderConfig'])(WALLET_CONSTANTS);
export const FILTERS_COUNTS_CONFIG = {
	[WALLET_CONSTANTS.FLIGHT_TYPE]: WALLET_CONSTANTS.FLIGHT_TYPE,
	[WALLET_CONSTANTS.FLIGHT_TYPE]: WALLET_CONSTANTS.FLIGHT_TYPE,
	[WALLET_CONSTANTS.HOTEL_TYPE]: WALLET_CONSTANTS.HOTEL_TYPE,
	[WALLET_CONSTANTS.MISC_TYPE]: WALLET_CONSTANTS.MISC_TYPE,
	[WALLET_CONSTANTS.CABS_TYPE]: WALLET_CONSTANTS.CABS_TYPE,
	[WALLET_CONSTANTS.BUS_TYPE]: WALLET_CONSTANTS.BUS_TYPE,
	[WALLET_CONSTANTS.MEALS_TYPE]: WALLET_CONSTANTS.MEALS_TYPE,
	[WALLET_CONSTANTS.TRAIN_TYPE]: WALLET_CONSTANTS.TRAIN_TYPE,
	[WALLET_CONSTANTS.DEBIT]: WALLET_CONSTANTS.DEBIT_COUNT,
	[WALLET_CONSTANTS.CREDIT]: WALLET_CONSTANTS.CREDIT_COUNT,
	[WALLET_CONSTANTS.E_COLLECTION]: WALLET_CONSTANTS.E_COLLECTION_COUNT,
	[WALLET_CONSTANTS.ONLINE]: WALLET_CONSTANTS.ONLINE_COUNT,
	[WALLET_CONSTANTS.OFFLINE]: WALLET_CONSTANTS.OFFLINE_COUNT
};
export const FILTERS_VALUES = evaluateString(getConsulData('config')['WALLET']['FILTER_VALUES'])(WALLET_CONSTANTS);

export const defaultCountConfig = {
	[WALLET_CONSTANTS.FLIGHT_TYPE]: 0,
	[WALLET_CONSTANTS.HOTEL_TYPE]: 0,
	[WALLET_CONSTANTS.MISC_TYPE]: 0,
	[WALLET_CONSTANTS.CABS_TYPE]: 0,
	[WALLET_CONSTANTS.BUS_TYPE]: 0,
	[WALLET_CONSTANTS.MEALS_TYPE]: 0,
	[WALLET_CONSTANTS.TRAIN_TYPE]: 0,
	[WALLET_CONSTANTS.DEBIT_COUNT]: 0,
	[WALLET_CONSTANTS.CREDIT_COUNT]: 0,
	[WALLET_CONSTANTS.E_COLLECTION_COUNT]: 0,
	[WALLET_CONSTANTS.ONLINE_COUNT]: 0,
	[WALLET_CONSTANTS.OFFLINE_COUNT]: 0
};

export const filters = evaluateString(getConsulData('config')['WALLET']['filters'])(WALLET_CONSTANTS, FILTER_CONSTANTS, INVOICE_CONSTANTS, APPLICATION_CONSTANTS);

export const defaultSubHeadeing = 'Last month till date';

export const reminderModalDtls = {
	title: 'Reminder Settings',
	desc: 'You will be notified through email whenever the wallet balance falls below specified amount.',
	details: [{
		isMulti: false,
		value: '',
		name: 'amount_limit',
		subtitle: 'Min amount below which you need to be notified',
		fieldLabel: 'Amount limit',
		key: 'amount_limit',
		type: 'text',
		formatVal: formatAmount,
		trackVal: 'reminder_settings_amount',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validAmount,
				msg: 'Enter Valid amount'
			}
		},
		errorOnBlur: true,
		className: 'rem-amount',
		isMandatory: true
	},
	{
		isMulti: false,
		value: '',
		errorOnBlur: true,
		name: 'days_left',
		scrollIntoView: true,
		fieldLabel: 'Days left',
		key: 'days_left',
		type: 'number',
		subtitle: 'Min no. of days your balance can suffice below which you need to be notified',
		trackVal: 'reminder_settings_days',
		validation: {
			custom: {
				validator: validDays,
				msg: 'Max 365 days is allowed'
			}
		}
	}
	],
	cta: {
		text: 'Save & Add Reminder',
		type: 'Primary'
	}
};

export const HELP_TEXT = getConsulData('config')['WALLET']['HELP_TEXT'];

export const walletBenefits = getConsulData('config')['WALLET']['walletBenefits'];

export const rechargeValues = getConsulData('config')['WALLET']['rechargeValues'];

export const walletInfoList = getConsulData('config')['WALLET']['walletInfoList'];

export const faqs = getConsulData('config')['WALLET']['faqs'];

export const RechargeOverlayModaldata = getConsulData('config')['WALLET']['RechargeOverlayModaldata'];

export const WALLET_OVERLAY_CONST = getConsulData('config')['WALLET']['WALLET_OVERLAY_CONST'];

export const TABLE_PROPS = getConsulData('config')['WALLET']['TABLE_PROPS'];

const cellProps = (customConfig = {}) => {
	const { customBodyClasses = {},
		customHeadClass = {},
		customCellProps = {} } = customConfig;
	return ({
		bodyCellProps: {
			size: 'medium',
			padding: '16px 9px',
			classes: {
				root: 'wallet_cell',
				...customBodyClasses
			},
			...customCellProps
		},
		headerCellProps: {
			size: 'medium',
			padding: '16px 9px',
			classes: {
				root: 'wallet_cell wallet_cell_head',
				...customHeadClass
			},
			...customCellProps
		}
	});
};

export const walletColumns = [
	{
		header: 'AMOUNT',
		accessor: 'txnAmount',
		formatter: (value)=><b>{value}</b>,
		...(cellProps({ customCellProps: { width: '130px', padding: '12px 9px' } }))
	},
	{
		header: 'Unique ID',
		accessor: 'uniqueId',

		formatter: (value)=>(
			<FlexDiv align='center'>
				<SpriteIcon icon={value.lob} right_M='10' />
				<div>
					<GenericP fsize='14px'>{value.bookingId}</GenericP>
					<GenericP color='#4a4a4a' fsize='12px'>{value.reason}</GenericP>
				</div>
			</FlexDiv>),
		...(cellProps({ customCellProps: { width: '130px', padding: '12px 9px' } }))
	},
	{
		header: 'EMAIL',
		accessor: 'emailId',

		formatter: (value)=>value,
		...(cellProps({ customCellProps: { width: '130px', padding: '12px 9px' } }))
	},
	{
		header: 'TYPE',
		accessor: 'type',

		formatter: (value)=><GenericP><DotIcon $bg={value.dotColor} /><GenericSpan transform='capitalize' left_M='3'>{value.type}</GenericSpan></GenericP>,
		...(cellProps({ customCellProps: { width: '130px', padding: '12px 9px' } }))
	},
	{
		header: 'TX DATE',
		accessor: 'txnDate',
		isSort: true,
		formatter: (value)=>value,
		...(cellProps({ customCellProps: { width: '130px', padding: '12px 9px' } }))
	},
	{
		header: 'EXPIRING ON',
		accessor: 'expiry',

		formatter: (value)=><GenericP color='#A5572A'>{value}</GenericP>,
		...(cellProps({ customCellProps: { width: '130px', padding: '12px 9px' } }))
	}
];

export const bonusFilterConfig = [{
	label: 'Flight',
	value: WALLET_CONSTANTS.FLIGHT_TYPE
},
{
	label: 'Hotel',
	value: WALLET_CONSTANTS.HOTEL_TYPE
},
{
	label: 'Cab',
	value: WALLET_CONSTANTS.CABS_TYPE
},
{
	label: 'Bus',
	value: WALLET_CONSTANTS.BUS_TYPE
},
{
	label: 'Train',
	value: WALLET_CONSTANTS.TRAIN_TYPE
}];

export const cashBacklobFilter = {
	isMulti: true,
	options: bonusFilterConfig,
	label: 'Booking Type'
};

export const cashBackTextConfig = getConsulData('config')['WALLET']['cashBackTextConfig'];
